var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgNtpIcon = function SvgNtpIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2a7 7 0 1 0 0 14A7 7 0 0 0 8 2m0 12.625a5.624 5.624 0 1 1 0-11.25 5.624 5.624 0 1 1 0 11.25m6.606-10.138a3 3 0 0 0-4.98-3.321 8 8 0 0 1 4.98 3.322zM6.374 1.166a3 3 0 0 0-4.98 3.321 8 8 0 0 1 4.98-3.322z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.457 11.043-1.414 1.414L8 10.414l-2.043 2.043-1.414-1.414L6.586 9 4.543 6.957l1.414-1.414L8 7.586l2.043-2.043 1.414 1.414L9.414 9z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNtpIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;